import Vue from 'vue'
import Vuex from 'vuex'
import StockList from './StockList.vue';
import axios from 'axios';
import ContactFormValidator from '../../../validation/ContactFormValidator';
import { generateLeadEvent } from '../../../modules/tracking/AnalyticsEvents';


const initStockList = function(rootEl) {
    const el = rootEl.querySelector('.cms-content-slice-stock-list__list');
    const formElement = rootEl.querySelector('.cms-content-slice-stock-list__form');
    const id = el.dataset.id;
    const locationHandler = new CustomerLocationHandler();
    let headerElementUpdateInterval = false;
    Vue.use(Vuex);

    let selectedModels = [];
    let selectedBrands = [];
    if (typeof window.location.search != 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('model')) {
            selectedModels = searchParams.getAll('model');
        }
        if (searchParams.has('brand')) {
            selectedBrands = searchParams.getAll('brand');
        }
    }

    const store = new Vuex.Store({
        state: {
            selectedOptions: {
                brands: selectedBrands,
                models: selectedModels,
                colours: [],
            },
            availableOptions: {
                brands: [],
                models: [],
                colours: [],
            },
            initialized: false,
            loadingOptions: true,
            loadingVehicles: true,
            vehicles: {},
        },
        actions: {
            getVehiclesAndOptions({ dispatch }) {
                dispatch('getOptions');
                dispatch('getVehicles');
            },
            getOptions({ commit, state }) {
                axios
                    .post('/api/stocklist/options', {
                        id: id,
                        ...state.selectedOptions,
                    })
                    .then(response => {
                        commit('setAvailableOptions', response.data);
                        commit('setLoadingOptions', false);
                        commit('setInitialized', true);
                        updateHeaderCount(response.data.total);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            getVehicles({ commit, state }) {
                axios
                    .post('/api/stocklist/vehicles', {
                        id: id,
                        ...state.selectedOptions,
                    })
                    .then(response => {
                        commit('setVehicles', response.data);
                        commit('setLoadingVehicles', false);

                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            getMoreVehicles({ commit, state }, page) {
                commit('setLoadingVehicles', true);
                axios
                    .post('/api/stocklist/vehicles', {
                        id: id,
                        page: page.page,
                        ...state.selectedOptions,
                    })
                    .then(response => {
                        commit('addVehicles', response.data);
                        commit('setLoadingVehicles', false);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            getOptionsAndVehicles({ commit, dispatch }) {
                dispatch('getOptions');
                dispatch('getVehicles');
            },
            updateOptions({ commit, dispatch }, options) {
                commit('updateOptions', options);
                dispatch('getOptionsAndVehicles');
            },
            enquireNow({}, vehicle) {
                if (!formElement) {
                    console.error('No stock list contact form found.');
                    return;
                }

                // set form heading
                formElement.querySelector('.cms-content-heading').innerHTML = `Enquire now to unbox your brand new ${vehicle.brand} ${vehicle.model}`;

                // set vehicle id
                const vehicleIdInput = formElement.querySelector('input[name="cms_content_slice_stocklist_id"]');
                vehicleIdInput.value = vehicle.id;

                const brand = vehicle.brand.toLowerCase();
                if (brand == 'citroën' || brand == 'citroen') {
                    locationHandler.updateBrand('citroen');
                } else if (brand == 'ds' || brand == 'peugeot' || brand == 'vauxhall' || brand == 'fiat' || brand == 'abarth') {
                    locationHandler.updateBrand(brand);
                } else if (brand == 'ds automobiles') {
                    locationHandler.updateBrand('ds');
                }

                // show form
                formElement.style.display = 'block';

                // scroll to form
                window.scrollTo({
                    top: formElement.offsetTop,
                    behavior: 'smooth',
                });
            },
        },
        mutations: {
            setAvailableOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.availableOptions[key] == 'undefined') {
                        return;
                    }
                    state.availableOptions[key] = options[key];
                });
            },
            setVehicles(state, vehicles) {
                state.vehicles = vehicles;
            },
            markVehicleReserved(state, vehicleId) {
                if (typeof state.vehicles.data == 'undefined') {
                    return;
                }
                console.log('markVehicleReserved', vehicleId, state);
                const vehiclesLength = state.vehicles.data.length;
                for (let index = 0; index < vehiclesLength; index++) {
                    const element = state.vehicles.data[index];
                    console.log('looking at', state.vehicles.data[index]);
                    console.log('looking at', element, state.vehicles.data[index].id);
                    if (element.id == vehicleId) {
                        console.log('MARK THIS VEHICLE', state.vehicles.data[index]);
                        state.vehicles.data[index].reserved_at = 'now';
                    }
                }
            },
            updateOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.selectedOptions[key] == 'undefined') {
                        return;
                    }
                    state.selectedOptions[key] = options[key];
                });
            },
            addVehicles(state, vehicles) {
                const previous = state.vehicles;
                state.vehicles = {
                    ...vehicles,
                    data: [
                        ...previous.data,
                        ...vehicles.data,
                    ]
                }
            },
            setInitialized(state, initialized) {
                state.initialized = initialized;
            },
            setLoadingOptions(state, loading) {
                state.loadingOptions = loading;
            },
            setLoadingVehicles(state, loading) {
                state.loadingVehicles = loading;
            },
        }
    })
    console.log('store', store);

    const app = new Vue({
        el,
        store,
        components: {
            StockList,
        },
        template: `<StockList />`,
    });

    const updateHeaderCount = function(newCount) {
        const stocklistHeader = document.getElementById('stock-list-header');
        if (headerElementUpdateInterval) {
            clearInterval(headerElementUpdateInterval);
        }
        if (stocklistHeader && stocklistHeader.dataset.loaded) {
            const event = new CustomEvent("stock_list_count_update", {
                detail: {
                    count: newCount
                },
            });
            window.dispatchEvent(event);
        } else {
            headerElementUpdateInterval = setInterval(function() {
                const event = new CustomEvent("stock_list_count_update", {
                    detail: {
                        count: newCount
                    },
                });
                window.dispatchEvent(event);
            }, 500);
        }
    };

    const initContactForm = async function() {
        console.log('init contact form');
        const formElement = rootEl.querySelector('.cms-content-slice__contact-us-form');
        const contactUsFormValidator = new ContactFormValidator({ element: formElement });
        locationHandler.setup(formElement);
        const contactFormText = document.querySelector('.cms-contact-form__text');

        formElement.addEventListener('submit', async function(e) {
            e.preventDefault();
            if (!await contactUsFormValidator.isValid()) {
                return false;
            }
            const formData = $(this).serializeArray();
            contactUsFormValidator.preventInput();
            $.ajax({
                url: formElement.getAttribute('action'),
                type: "POST",
                data: formData,
                cache: false,
                dataType: "json",
                success: function (response) {
                    store.dispatch('getOptions');
                    window.scrollTo({ top: $(formElement).offset().top - 200, behavior: 'smooth' });

                    generateLeadEvent('cms_form_event_combined');

                    contactFormText.style.display = 'none';
                    formElement.innerHTML = `
                        <h3 class="cms-content-heading" style="font-size: 20px;font-weight: 700;margin: 0;">Thank you for unboxing a great offer!</h3>
                        <p>We have sent your information onto our customer hub team who will be in contact with you as soon as possible.</p>
                        <p>If you would like receive a free instant valuation on your current vehicle please use the link below.</p>

                        <a href="/car-valuation" class="btn btn--primary">Value my car</a>
                    `;
                    contactUsFormValidator.allowInput();
                    store.commit('markVehicleReserved', response.vehicle);
                },
                error: function (response) {
                    contactUsFormValidator.errorResponse(response);
                }
            });
        });
    };
    initContactForm();
};


const stocklist = document.querySelectorAll('.cms-content-slice-stock-list');
const stocklistLength = stocklist.length;
if (stocklistLength > 0) {
    for (let index = 0; index < stocklistLength; index++) {
        initStockList(stocklist[index]);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/components/stock-list/initStockList.js